import Swal from "sweetalert2";
import { toast } from "react-toastify";

export const confirmAndDelete = async ({
  uuid,
  dispatch,
  deleteThunk,
  successMessage = "Deleted successfully.",
  errorMessage = "Failed to delete.",
  isDanger = true,
  payloadBuilder, 
}) => {
  const result = await Swal.fire({
    title: "Are you sure?",
    text: "This will delete it permanently.",
    icon: "warning",
    showCancelButton: true,
    customClass: {
      confirmButton: isDanger
        ? "btn btn-danger me-2"
        : "btn btn-primary me-2",
      denyButton: "btn btn-outline-secondary",
      popup: "card",
      title: "text-headings",
      htmlContainer: "text-body",
    },
    confirmButtonText: "Yes, delete it!",
  });

  if (!result.isConfirmed) return;

  try {
    const payload = payloadBuilder ? payloadBuilder(uuid) : uuid;

    await dispatch(deleteThunk(payload)).unwrap();

    toast.success(successMessage);
  } catch (error) {
    toast.error(
      error?.message || errorMessage
    );
  }
};

